import { ref } from 'vue';
import html2pdf from 'html2pdf.js';
import { buildPdfHtml, type ResumeData } from '@/utils/pdfTemplates';

export function usePdfExport() {
  const isGenerating = ref(false);

  const getFilename = (type: 'albaran' | 'presupuesto'): string => {
    const date = new Date();
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${type}-${y}-${m}-${d}.pdf`;
  };

  const downloadPdf = async (
    type: 'albaran' | 'presupuesto',
    resume: ResumeData
  ): Promise<void> => {
    if (!resume?.listProducts?.length) {
      return;
    }
    isGenerating.value = true;

    const wrapper = document.createElement('div');
    wrapper.id = 'pdf-export-temp';
    wrapper.setAttribute(
      'style',
      'position:absolute;left:-9999px;top:0;width:210mm;'
    );
    wrapper.innerHTML = buildPdfHtml(type, resume);
    document.body.appendChild(wrapper);

    const element = wrapper.firstElementChild;
    if (!element) {
      document.body.removeChild(wrapper);
      isGenerating.value = false;
      return;
    }

    const opt: Record<string, unknown> = {
      margin: 15,
      filename: getFilename(type),
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait' as const,
      },
    };
    if (type === 'presupuesto') {
      opt.pagebreak = { mode: 'css', avoid: '.no-break' };
    }

    try {
      await html2pdf().set(opt).from(element).save();
    } catch (err) {
      console.error('Error generando PDF:', err);
      throw err;
    } finally {
      if (wrapper.parentNode) {
        document.body.removeChild(wrapper);
      }
      isGenerating.value = false;
    }
  };

  return {
    isGenerating,
    downloadPdf,
  };
}
